import { TranslationContext } from "@clockwise/client-commons/src/providers/TranslationContext";
import { getNextDefragText } from "@clockwise/client-commons/src/util/defrag";
import { Link } from "@clockwise/design-system";
import { ChevronRight } from "@clockwise/design-system/icons";
import { FlowState } from "@clockwise/schema";
import pluralize from "pluralize";
import React, { useContext } from "react";
import { AutopilotStatusCard } from "./AutopilotStatusCard";

type Props = {
  flowState: FlowState | null | undefined;
  nextDefragTime: number | undefined;
  meetingsMoved: number | undefined;
  defragError?: boolean;
  onClick?: () => void;
};

export function AutopilotStatusFinished({
  flowState,
  nextDefragTime,
  meetingsMoved,
  defragError = false,
  onClick,
}: Props) {
  const t = useContext(TranslationContext);

  if (!nextDefragTime) {
    return null;
  }

  if (!!flowState?.current?.errorMessage || meetingsMoved === undefined || defragError) {
    return (
      <AutopilotStatusCard
        title={t("autopilot-status:error")}
        description="Will try again tomorrow"
        tooltipText="Something went wrong with Autopilot.  Your schedule wasn't updated and no further action is required."
        onClick={onClick}
        warning
      />
    );
  } else if (meetingsMoved === 0) {
    return (
      <AutopilotStatusCard
        title={t("autopilot-status:no-update")}
        description={`Next run ${getNextDefragText(nextDefragTime)}`}
        tooltipText="Clockwise considers a number of factors when searching for better times, and won't move a meeting unless all are satisfied."
      />
    );
  } else {
    const description = `${pluralize("meeting", meetingsMoved, true)} updated`;
    return (
      <AutopilotStatusCard
        title="Your schedule was optimized"
        description={
          <>
            {onClick ? <Link>{description}</Link> : <div>{description}</div>}
            {onClick ? <ChevronRight className="cw-h-5 cw-w-5 cw-text-brand" /> : null}
          </>
        }
        onClick={onClick}
      />
    );
  }
}
